import { detectFeatureToggles, asString, asBoolean } from '@rio-cloud/rio-uikit/urlFeatureToggles';

import { useUserAccount } from '../login/loginSlice';

// Define old toggles to clean up
const oldToggles = ['ft_eventTeaser', 'ft_survey', 'ft_menu', 'ft_groupedPois', 'ft_featureVoting'];

// Define toggle transformation functions with their respective names and
// export the detected feature toggles as a singleton
export const featureToggles = detectFeatureToggles(
    {
        enforcedEnv: asString('ft_env'),
        enforcedLocale: asString('ft_enforceLocale'),
        enforcedLocalWidget: asString('ft_localWidget'),
        tracing: asBoolean('ft_tracing'),
        support: asBoolean('ft_support'),
        demo: asBoolean('ft_demo'),
        simulateGeoBooked: asString('ft_simulateGeoBooked'),
        smartRoutePlanning: asBoolean('ft_smartRoutePlanning'),
        smartRoutePlanningBooking: asBoolean('ft_srpBooking'),
        devMode: asBoolean('ft_devMode'),
        skipChristmas: asBoolean('skipChristmas'),
        platformNotifications: asBoolean('ft_platformNotifications'),
    },
    oldToggles
);

export const useWhiteListedFeatureToggles = (whiteList: string[] = []) => {
    const accountId = useUserAccount();
    return whiteList.includes(accountId);
};

export const useSmartRouteFeatureToggle = () => {
    const smartRouteWhiteList = [
        'mockaccount',
        '8ef04c71-8105-4bfb-a97c-a70db9d66975',
        '237c58e3-60b5-4442-a9ec-8641ea39325b',
        '284b3c1f-72c1-4669-a51b-c7ca9cc3c967',
        'ac464fce-f700-49a7-aa13-60b0c5c3f9ce',
        '0eaa962f-ddf9-4280-9d37-3d0760959493',
        'be0fa59d-6b42-4025-9039-1c1ac8efb4e1',
        '0ff74f0d-c891-47ca-a7e6-9501be388fe7',
        '482df194-8e57-4e45-ba4d-691ad2d21908',
        '3d8eac7c-d6f4-422e-90bc-a6fa7778e9f0',
        'a8ade106-59f4-4d7d-822f-790adcf1de89',
        'a350fdb9-9af5-4123-a0dc-e6b2c61c8ae7',
        '1cea77ad-5ce2-4452-b0af-6cae14ab5f5f',
        '3a3f27f1-c499-477b-8a21-bb0a09d6556b',
    ];
    return useWhiteListedFeatureToggles(smartRouteWhiteList);
};
